import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import { GoogleLogin } from "react-google-login";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./CourseLogin.css";
import {
  SignIn,
  ForgotPassword,
  SocialSignIn,
} from "../../../redux/reducers/auth";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { AppHeader } from "@coreui/react";
import DefaultHeader from "../../Header/DefaultHeader";

const CourseLogin = () => {
  const { translationState } = useSelector((state) => state.user);
  const { userLanguage } = useSelector((state) => state.auth);

  const registerTranslation =
    translationState?.[0]?.translations?.register?.[userLanguage];

  const logInTranslation =
    translationState?.[0]?.translations?.logIn?.[userLanguage];

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get("redirect");

  const [signInObject, setSignInObject] = useState({
    email: "",
    password: "",
  });

  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const event = location.state?.event;

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user?.user?.id && event) {
      history.push({
        pathname: "/course-checkout",
        state: { user_id: user.user.id, event },
      });
    }
  }, [user, history, event]);

  useEffect(() => {
    if (redirect === "/my-cart") {
      const message = toastTranslation["you_must_login_to_continue"]?.[userLanguage] || 
                     toastTranslation["you_must_login_to_continue"]?.["en"] || 
                     "You must login to continue";
      toast.error(message);
    }
  }, [redirect, userLanguage]);

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setSignInObject({
      ...signInObject,
      [name]: value,
    });
  };

  const validateEmail = (email) => {
    const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    return isValid;
  };

  const clearErrors = () => {
    setEmailError(false);
    setPasswordError(false);
  };

  const signIn = () => {
    clearErrors();
    if (signInObject.email === "" || !validateEmail(signInObject.email)) {
      setEmailError(true);
    } else if (signInObject.password === "") {
      setPasswordError(true);
    } else {
      dispatch(SignIn(signInObject)).then((response) => {
        if (response?.payload?.user?.id) {
          const user_id = response.payload.user.id;
          if (user_id && event) {
            history.push({
              pathname: "/course-checkout",
              state: { user_id, event },
            });
          } else {
            history.push("/personal-finance");
          }
        } else {
          toast.error("");
        }
      });
    }
  };

  const googleSignIn = (response) => {
    clearErrors();
    const { profileObj, tokenObj, details } = response;
    if (tokenObj?.id_token) {
      const { email, familyName, givenName } = profileObj;
      const data = {
        firstname: familyName,
        lastname: givenName,
        email,
      };
      dispatch(SocialSignIn(data));
    } else {
      if (details) toast.info(details);
      else toast.error("Some error occurred during Google SignIn");
    }
  };

  return (
    <div className="login-main-wrapper">
      <Row className="fixed-header">
        <AppHeader fixed>
          <DefaultHeader />
        </AppHeader>
      </Row>
      <div className="app flex-row align-items-center login-background">
        <ToastContainer autoClose={20000} />
        <Container>
          <Row>
            <Col xs="0" sm="0" md="6" lg="6">
              <div className="hide-on-mobile welcome-back">
                {logInTranslation?.headingOne
                  ? logInTranslation?.headingOne
                  : "Welcome Back,"}
              </div>
              <div className="hide-on-mobile open-the-door">
                {logInTranslation?.headingTwo
                  ? logInTranslation?.headingTwo
                  : "Open the door,"}
              </div>
              <div className="hide-on-mobile you-have-the-key">
                {logInTranslation?.headingThree
                  ? logInTranslation?.headingThree
                  : "you already have the key!"}
              </div>
            </Col>
            <Col xs="12" sm="12" md="6" lg="6">
              <Card style={{ width: "100%", padding: "0", height: 720 }}>
                <CardHeader
                  style={{
                    display: "flex",
                    backgroundColor: "#ffffff",
                    padding: "0",
                    borderBottom: "0",
                  }}
                >
                  <div
                    className="signin-tab-text-register"
                    style={{
                      width: "50%",
                      height: "80px",
                      backgroundColor: "#000000",
                    }}
                    onClick={() => history.push("/login")}
                  >
                    {logInTranslation?.signInButton
                      ? logInTranslation?.signInButton
                      : "Sign In"}
                  </div>
                  <div
                    onClick={() => history.push("/register")}
                    className="register-tab-text-register"
                    style={{
                      width: "50%",
                      height: "80px",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    {logInTranslation?.registerButton
                      ? logInTranslation?.registerButton
                      : "Register"}
                  </div>
                </CardHeader>
                <CardBody style={{ height: "600px" }}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "30px",
                    }}
                  >
                    <div className="title-register">
                      {logInTranslation?.signInButton
                        ? logInTranslation?.signInButton
                        : "Sign In"}
                    </div>
                    <div className="login-tagline">
                      {logInTranslation?.paraOne
                        ? logInTranslation?.paraOne
                        : "Let's start the journey. Sign in here..."}
                    </div>
                    <InputGroup className="mb-1" style={{ marginTop: "50px" }}>
                      <Input
                        type="text"
                        onChange={handleInputChange}
                        value={signInObject.email}
                        name="email"
                        placeholder={
                          registerTranslation?.emailPlaceHolder
                            ? registerTranslation?.emailPlaceHolder
                            : "Email"
                        }
                        className="login-input"
                      />
                    </InputGroup>
                    <InputGroup className="mb-1">
                      <div className="error-text" hidden={!emailError}>
                        {registerTranslation?.emailPlaceHolder
                          ? registerTranslation?.emailPlaceHolder
                          : "please enter valid email address."}
                      </div>
                    </InputGroup>
                    <InputGroup className="mb-1">
                      <Input
                        type="password"
                        onChange={handleInputChange}
                        value={signInObject.password}
                        name="password"
                        className="login-input"
                        placeholder={
                          registerTranslation?.passwordPlaceHolder
                            ? registerTranslation?.passwordPlaceHolder
                            : "Password"
                        }
                      />
                    </InputGroup>
                    <InputGroup className="mb-1">
                      <div className="error-text" hidden={!passwordError}>
                        {registerTranslation?.passwordPlaceHolder
                          ? registerTranslation?.passwordPlaceHolder
                          : "Please enter valid password."}
                      </div>
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <Button
                        color="link"
                        onClick={() => history.push("/auth/forgot-password")}
                        className="px-0"
                      >
                        {logInTranslation?.forgetPassword
                          ? logInTranslation?.forgetPassword
                          : "Forgot password?"}
                      </Button>
                    </InputGroup>
                    <Button
                      onClick={() => signIn()}
                      className="register-button"
                      block
                    >
                      <b>
                        {logInTranslation?.signInButton
                          ? logInTranslation?.signInButton
                          : "Sign In"}
                      </b>
                    </Button>

                   
                  </div>
                </CardBody>
                <CardFooter>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {logInTranslation?.signInWith
                      ? logInTranslation?.signInWith
                      : "or Sign in using"}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <GoogleLogin
                      clientId="367945858566-41odj8kbjqvsbhemsua8jc83emvs99pt.apps.googleusercontent.com"
                      buttonText="Login"
                      render={(renderProps) => (
                        <Button
                          className="google_btn"
                          disabled={renderProps.disabled}
                          onClick={renderProps.onClick}
                        >
                          Google
                        </Button>
                      )}
                      onSuccess={googleSignIn}
                      onFailure={googleSignIn}
                    />
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default CourseLogin;